<template>

    <div class="login-container">
        <b-card header-tag="header"
                header-bg-variant="primary"
                header-text-variant="white"
                class="login-card"
                data-aos="fade-down">
            <template #header>
                <div class="header">
                    <img :src="logoUrl" alt="" class="mr-auto">
                    <div class="text">{{ t.__('Panel użytkownika') }}</div>
                </div>
            </template>
            <b-card-text>
                <b-form-group
                    id="auth-login-token"
                    description=""
                    :label="t.__('Token dostępu')"
                    valid-feedback=""
                    :invalid-feedback="form.errors.get('token')"
                    :state="true"
                    :disabled="processing">
                    <b-form-input id="auth-login-token" v-model="form.token" :state="form.errors.state('token')" autofocus trim></b-form-input>
                </b-form-group>

                <b-button variant="success" block class="mt-3" @click="login" v-text="processing ? t.__('Loguję...') : t.__('Zaloguj')" :disabled="processing"></b-button>

            </b-card-text>
        </b-card>

        <div class="auth-lang-switch">
            <a v-for="(name, code) in CONFIG.availableLocales" :key="code" :class="{'active': CONFIG.currentLocale === code}" :href="'/set-locale/' + code">{{ name }}</a>
        </div>


    </div>

</template>

<script>

export default {

    name: 'LoginForm',

    data() {
        return {
            form: new Vue.prototype.Form({
                token: null
            }),
            processing: false
        }
    },

    computed: {
        logoUrl() {
            let url = '/assets/images/';
            switch (CONFIG.currentLocale) {
                case 'pl':
                    url += 'logo-pl.svg';
                    break;
                case 'fr':
                    url += 'logo-fr.svg';
                    break;
                default:
                    url += 'logo-en.svg';
                    break;
            }
            return url;
        }
    },

    methods:  {

        login() {
            this.processing = true;
            this.form.post('/authenticate')
                .then(response => {
                    window.location.replace('/');
                })
                .catch(error => {
                    console.log(error);
                    this.processing = false;
                });
        }

    }

}

</script>

<style scoped>

</style>
